import { useCallback } from 'react'
import classNames from 'classnames'
import HelpTooltip from '../../../../components/tooltip/HelpTooltip'
import { CampaignTypes } from '../../../Codes'
import RadioButton from '../../../../components/form/RadioButton'
import CheckBox from '../../../../components/form/CheckBox'
import { useDispatch, useSelector } from 'react-redux'
import ErrorText from '../../../../components/form/ErrorText'
import PropTypes from 'prop-types'
import {
  addPlacementCategories,
  removePlacementCategories,
  setPlacementType,
  togglePlacementCategories,
} from '../adGroupSlice'

const PlacementCategoriesToAdd = {
  PREMIUM_LINK_SEARCH: ['PREMIUM_LINK_SEARCH_KAKAO'],
  PREMIUM_LINK_CONTENT: [
    'PREMIUM_LINK_CONTENT_KAKAO',
    'PREMIUM_LINK_CONTENT_PARTNER',
  ],
}
const PlacementCategoriesToRemove = {
  PREMIUM_LINK_SEARCH: [
    'PREMIUM_LINK_SEARCH_KAKAO',
    'PREMIUM_LINK_SEARCH_PARTNER',
  ],
  PREMIUM_LINK_CONTENT: [
    'PREMIUM_LINK_CONTENT_KAKAO',
    'PREMIUM_LINK_CONTENT_PARTNER',
  ],
}
const Placement = ({ error }) => {
  const dispatch = useDispatch()
  const {
    campaign: {
      form: { campaignType },
    },
    adGroup: {
      form: { placementType, placementCategories },
    },
  } = useSelector(state => state.ad)
  const handlePlacementTypeChange = useCallback(
    value => dispatch(setPlacementType(value)),
    [dispatch]
  )
  const handlePlacementCategoriesChange = useCallback(
    ({ target: { value, checked } }) => {
      if (checked) {
        dispatch(addPlacementCategories(PlacementCategoriesToAdd[value]))
      } else {
        dispatch(removePlacementCategories(PlacementCategoriesToRemove[value]))
      }
    },
    [dispatch]
  )
  const handlePlacementCategoryChange = useCallback(
    ({ target: { value } }) => dispatch(togglePlacementCategories([value])),
    [dispatch]
  )
  return (
    <div className={classNames('area_item', { error })}>
      <strong className="subtit_box">
        매체유형
        <HelpTooltip>
          {campaignType === CampaignTypes.TALK_CHANNEL ? (
            '검색 매체는 검색어와 광고를 매칭하는 게재지면을 의미합니다.'
          ) : (
            <>
              검색 매체는 검색어와 광고를 매칭하는 게재지면을 의미하며,
              <br />
              콘텐츠 매체는 문맥과 광고를 매칭하는 게재지면을 의미합니다.
            </>
          )}
        </HelpTooltip>
      </strong>
      <div className="cont_card">
        {campaignType === CampaignTypes.TALK_CHANNEL ? (
          <p className="desc_g">검색 매체 카카오</p>
        ) : (
          <div className="item_card">
            <ul className="list_radiocheck">
              <li>
                <RadioButton
                  name="placementType"
                  value="ALL"
                  label="전체"
                  tiaraAction="매체유형_전체_클릭"
                  checked={placementType === 'ALL'}
                  onValueChange={handlePlacementTypeChange}
                />
              </li>
              <li>
                <RadioButton
                  name="placementType"
                  value="SETTING"
                  label="상세설정"
                  tiaraAction="매체유형_상세설정_클릭"
                  checked={placementType === 'SETTING'}
                  onValueChange={handlePlacementTypeChange}
                />
              </li>
            </ul>
            {placementType === 'SETTING' && (
              <div className="box_subcard">
                <strong className="screen_out">매체 유형 상세 설정</strong>
                <ul className="list_radiocheck">
                  <li>
                    <CheckBox
                      label="검색 매체"
                      tiaraAction="매체유형_검색매체_전체_클릭"
                      value="PREMIUM_LINK_SEARCH"
                      checked={
                        placementCategories.includes(
                          'PREMIUM_LINK_SEARCH_KAKAO'
                        ) ||
                        placementCategories.includes(
                          'PREMIUM_LINK_SEARCH_PARTNER'
                        )
                      }
                      onChange={handlePlacementCategoriesChange}
                    />
                    <ul className="list_radiocheck">
                      <li>
                        <CheckBox
                          label="카카오, 다음"
                          name="placementCategories"
                          value="PREMIUM_LINK_SEARCH_KAKAO"
                          checked={placementCategories.includes(
                            'PREMIUM_LINK_SEARCH_KAKAO'
                          )}
                          onChange={handlePlacementCategoryChange}
                          tiaraAction="매체유형_검색매체_카카오_클릭"
                        />
                      </li>
                    </ul>
                  </li>
                  <li>
                    <CheckBox
                      label="콘텐츠 매체"
                      tiaraAction="매체유형_콘텐츠매체_전체_클릭"
                      value="PREMIUM_LINK_CONTENT"
                      checked={
                        placementCategories.includes(
                          'PREMIUM_LINK_CONTENT_KAKAO'
                        ) ||
                        placementCategories.includes(
                          'PREMIUM_LINK_CONTENT_PARTNER'
                        )
                      }
                      onChange={handlePlacementCategoriesChange}
                    />
                    <ul className="list_radiocheck">
                      <li>
                        <CheckBox
                          label="카카오, 다음"
                          name="placementCategories"
                          value="PREMIUM_LINK_CONTENT_KAKAO"
                          checked={placementCategories.includes(
                            'PREMIUM_LINK_CONTENT_KAKAO'
                          )}
                          onChange={handlePlacementCategoryChange}
                          tiaraAction="매체유형_콘텐츠매체_카카오_클릭"
                        />
                      </li>
                      <li>
                        <CheckBox
                          label="파트너"
                          name="placementCategories"
                          value="PREMIUM_LINK_CONTENT_PARTNER"
                          checked={placementCategories.includes(
                            'PREMIUM_LINK_CONTENT_PARTNER'
                          )}
                          onChange={handlePlacementCategoryChange}
                          tiaraAction="매체유형_콘텐츠매체_파트너_클릭"
                        />
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            )}
            <ErrorText error={error} tag="p" />
          </div>
        )}
      </div>
    </div>
  )
}
Placement.propTypes = {
  error: PropTypes.string,
}
export default Placement
